import PropTypes from "prop-types";
import React from "react";
import colors from "../styles/colors";
import styled from "styled-components";
import Icon from "./Icon";

const Input = ({ className, type, align, full, round, onChange, disabled, value, placeHolder, margin }) => {
  function getMargin() {
    if (margin) {
      return margin;
    }

    if (align === "right") {
      return "0 0 16px auto";
    } else if (align === "center") {
      return "0 auto 16px";
    } else {
      return "0 0 16px";
    }
  }

  function getClassName() {
    var classes = [];
    if (className) {
      classes.push(className);
    }
    if (full) {
      classes.push("-full");
    }
    if (round) {
      classes.push("-round");
    }
    if (disabled) {
      classes.push("-disabled");
    }
    if (type === "text-icon") {
      classes.push("-icon");
    }
    if (classes.length > 0) {
      return classes.join(" ");
    }
  }

  let output;

  switch (type) {
    case "text-icon":
      output = (
        <StyledWrapper className={getClassName()}>
          <StyledIcon className={getClassName()} name="icon-search" size="16px"></StyledIcon>
          <StyledInput
            className={getClassName()}
            textColor={colors.mainText}
            borderColor={colors.inputBorder}
            minWidth="100px"
            margin={getMargin()}
            onChange={onChange}
            disabled={disabled}
            value={value}
            placeholder={placeHolder}
          />
        </StyledWrapper>
      );

      break;
    default:
      output = (
        <StyledInput
          className={getClassName()}
          textColor={colors.mainText}
          borderColor={colors.inputBorder}
          minWidth="100px"
          margin={getMargin()}
          onChange={onChange}
          disabled={disabled}
          value={value}
          placeholder={placeHolder}
        />
      );
  }

  return output;
};

const StyledWrapper = styled.div`
  position: relative;

  &.-full {
    width: 100%;
  }
`;

const StyledIcon = styled(Icon)`
  position: absolute;
  top: 18px;
  left: 5px;
`;

const StyledInput = styled.input.attrs((props) => ({
  textColor: props.textColor || colors.black,
  padding: props.padding || "10px 16px",
  margin: props.margin || "0px",
  borderColor: props.borderColor || colors.black,
  minWidth: props.minWidth,
  onChange: props.onChange,
}))`
  display: block;
  font-size: 14px;
  border-radius: 6px;
  font-family: "Poppins", "Kanit", "Helvetica Neue", sans-serif;
  min-width: ${(props) => props.minWidth};
  color: ${(props) => props.textColor};
  padding: ${(props) => props.padding};
  margin: ${(props) => props.margin};
  border: 1px solid ${(props) => props.borderColor};

  &.-full {
    width: 100%;
  }

  &.-round {
    border-radius: 80px;
  }

  &.-disabled {
    opacity: 0.5;
  }

  &.-icon {
    padding-left: 30px;
    box-sizing: border-box;
  }

  &:only-child {
    margin-bottom: 0;
  }
`;

Input.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  className: PropTypes.string,
  type: PropTypes.string,
  align: PropTypes.string,
  full: PropTypes.bool,
  round: PropTypes.bool,
};

export default Input;
